import { trans } from './trans';

export const warnBeforeUnload = (event: BeforeUnloadEvent): void => {
    event.returnValue = trans('basic.warning.beforeUnload');
};
